<template>
  <div class="section">
    <div class="section_left">
      <h2>關於樂團，你可能想知道...</h2>
      <p>
        《民視新聞網》採訪金曲歌王朱頭皮老師，帶大家一窺台灣樂團歷史，窺探影響整個樂壇的大事件；更分析從實體唱片時期，到現今網路串流發達的環境衝擊；也爬梳整理台灣音樂創作的脈絡，細數台灣獨一無二的精神與文化。
      </p>
      <div class="btn pc">
        <button id="button1">做音樂真的能當飯吃嗎？</button>
        <button id="button2">商業化不好嗎？創作自由與價值呢？</button>
        <button id="button3">紅了之後，還能叫做獨立樂團嗎？</button>
        <button id="button4">金曲逐年金音化？矛盾現象怎麼解？</button>
      </div>
      <div class="btn mb">
        <button id="button1_mb">做音樂真的能當飯吃嗎？</button>
        <div id="section1_mb" class="section1" style="display:none">
          <p> 音樂產業生存不易，踏上音樂這條路又成功的人士少之又少，而音樂真的能當飯吃嗎？有成功的SOP嗎？又要保持怎樣的心態呢？ </p>
          <div class="videobox">
            <iframe src="https://www.youtube.com/embed/iiGX4X5BvCY" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
          </div>
          <a href="https://www.ftvnews.com.tw/news/detail/2023329W0218" target="_blank">
            點我看金曲歌王深度訪談解析
          </a>

        </div>
        <button id="button2_mb">商業化不好嗎？創作自由與價值呢？</button>
        <div id="section2_mb" class="section2" style="display:none">
          <p> 在商業化的今天，市場為重的觀念普遍存在，但創作自由和價值同樣重要。那麼，商業化到底是好還是不好？創作自由和價值如何平衡？ </p>
          <div class="videobox">
            <iframe src="https://www.youtube.com/embed/t2Sjry-_Chk" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
          </div>
          <a href="https://www.ftvnews.com.tw/news/detail/2023329W0232" target="_blank">
            點我看金曲歌王深度訪談解析
          </a>

        </div>
        <button id="button3_mb">紅了之後，還能叫做獨立樂團嗎？</button>
        <div id="section3_mb" class="section3" style="display:none">
          <p> 起初獨立樂團較被歸類於較沒有資金、沒有市場的創作者們，需要以自身力量籌措經費、產製作品。但時至今日，「獨立」與「主流」的界線似乎越來越模糊......</p>
          <div class="videobox">
            <iframe src="https://www.youtube.com/embed/CqVebsgHlQ0" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
          </div>
          <a href="https://www.ftvnews.com.tw/news/detail/2023330W0253" target="_blank">
            點我看金曲歌王深度訪談解析
          </a>

        </div>

        <button id="button4_mb">金曲獎逐年金音化？矛盾現象怎麼解？</button>
        <div id="section4_mb" class="section4" style="display:none">

          <p> 近幾屆的金曲獎、金音獎，許多得獎人都頗為相似，那這樣台灣還有需要同時保有這兩種獎項嗎？原本要將商業性區分開的的金音獎，是否造成地位鬆動？</p>
          <div class="videobox">
            <iframe src="https://www.youtube.com/embed/CP7jN1ULlI4" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
          </div>
          <a href="https://www.ftvnews.com.tw/news/detail/2023330W0332" target="_blank">
            點我看金曲歌王深度訪談解析
          </a>
        </div>
      </div>
    </div>
    <div class="section_right pc">
      <div id="section1" class="section1">
        <div class="videobox">
          <iframe src="https://www.youtube.com/embed/iiGX4X5BvCY" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>
        </div>
        <p>音樂產業生存不易，踏上音樂這條路又成功的人士少之又少，而音樂真的能當飯吃嗎？有成功的SOP嗎？又要保持怎樣的心態呢？</p>
        <a href="https://www.ftvnews.com.tw/news/detail/2023329W0218" target="_blank">
          點我看金曲歌王深度訪談解析
        </a>

      </div>
      <div id="section2" class="section2" style="display:none">
        <div class="videobox">
          <iframe src="https://www.youtube.com/embed/t2Sjry-_Chk" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>
        </div>
        <p> 在商業化的今天，市場為重的觀念普遍存在，但創作自由和價值同樣重要。那麼，商業化到底是好還是不好？創作自由和價值如何平衡？</p>
        <a href="https://www.ftvnews.com.tw/news/detail/2023329W0232" target="_blank">
          點我看金曲歌王深度訪談解析
        </a>

      </div>
      <div id="section3" class="section3" style="display:none">
        <div class="videobox">
          <iframe src="https://www.youtube.com/embed/CqVebsgHlQ0" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>
        </div>
        <p> 起初獨立樂團較被歸類於較沒有資金、沒有市場的創作者們，需要以自身力量籌措經費、產製作品。但時至今日，「獨立」與「主流」的界線似乎越來越模糊......
        </p>

        <a href="https://www.ftvnews.com.tw/news/detail/2023330W0253" target="_blank">
          點我看金曲歌王深度訪談解析
        </a>

      </div>
      <div id="section4" class="section4" style="display:none">
        <div class="videobox">
          <iframe src="https://www.youtube.com/embed/CP7jN1ULlI4" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>
        </div>
        <p>近幾屆的金曲獎、金音獎，許多得獎人都頗為相似，那這樣台灣還有需要同時保有這兩種獎項嗎？原本要將商業性區分開的的金音獎，是否造成地位鬆動？
        </p>

        <a href="https://www.ftvnews.com.tw/news/detail/2023330W0332" target="_blank">
          點我看金曲歌王深度訪談解析
        </a>

      </div>



    </div>



  </div>
</template>

<script>

/*eslint-disable*/
$(document).ready(function () {
  $('#button1').click(function (e) {
    e.stopPropagation();
    if ($('#section1').show()) {
      $('#section2,#section3,#section4').hide()
    }
  })
  $('#button2').click(function (e) {
    e.stopPropagation();
    if ($('#section2').show()) {
      $('#section1,#section3,#section4').hide()
    }
  })
  $('#button3').click(function (e) {
    e.stopPropagation();
    if ($('#section3').show()) {
      $('#section2,#section1,#section4').hide()
    }
  })
  $('#button4').click(function (e) {
    e.stopPropagation();
    if ($('#section4').show()) {
      $('#section2,#section3,#section1').hide()
    }
  })
  $('#button1_mb').click(function (e) {
    e.stopPropagation();
    if ($('#section1_mb').show()) {
      $('#section2_mb,#section3_mb,#section4_mb').hide()
    }
  })
  $('#button2_mb').click(function (e) {
    e.stopPropagation();
    if ($('#section2_mb').show()) {
      $('#section1_mb,#section3_mb,#section4_mb').hide()
    }
  })
  $('#button3_mb').click(function (e) {
    e.stopPropagation();
    if ($('#section3_mb').show()) {
      $('#section2_mb,#section1_mb,#section4_mb').hide()
    }
  })
  $('#button4_mb').click(function (e) {
    e.stopPropagation();
    if ($('#section4_mb').show()) {
      $('#section2_mb,#section3_mb,#section1_mb').hide()
    }
  })

})

</script>


<style scoped>
#button4_mb {
  white-space: nowrap;
}

.videobox {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}

.videobox iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.section {
  border-radius: 30px;
  border: 2px solid black;
  display: grid;
  grid-template-columns: 1fr 2fr;
  margin: auto;
  max-width: 1300px;
  background-image: url('../assets/sectionbg.png');
}


@media screen and (max-width:900px) {
  .section {
    grid-template-columns: 2fr 3fr;
  }
}

@media screen and (max-width:768px) {
  .section {
    grid-template-columns: 1fr;
  }
}

.section_left {
  border-right: 2px solid black;
  padding: 2rem;
  display: grid;
}



.nav a:hover:before {
  content: url('https://www.ftvnews.com.tw/topics/taiwanband/img/star_yellow.png');
  transition: .2s all;
}

.section_right {
  padding: 3rem 2rem;
}

.section_right img {
  width: 100%;
  margin: auto;
  margin-bottom: 1rem;
  border-radius: 30px 30px 0px 0px;
}

iframe {
  width: 100%;
  margin: auto;
  margin-bottom: 1rem;
  border-radius: 30px 30px 0px 0px;
}

.section_right p {}

.section_right button {
  margin-right: 0rem;
}

button {
  padding: 0.5rem 0.8rem;
  font-weight: bold;
}

@media screen and (max-width:768px) {
  .section {
    margin: 1rem;
  }

  .section_left {
    border-right: none;
    padding: 0rem;
    width: 95%;
    margin: auto;
    display: block;
  }

  .section_left p {
    margin: 1rem auto;
    text-align: center;
  }

  button {
    margin: 1rem auto;
    padding: 0.4rem 0.8rem;
    font-weight: bold;
  }

  .section_left h2 {
    margin: 1rem auto;
    white-space: nowrap;
  }

}


button {
  width: 100%;
}


button:hover {
  background: rgba(251, 185, 28, 0.5);
  transition: all .5s;
  cursor: pointer;
}



a {
  border-radius: 25px;
  padding: .3rem .5rem;
  margin: 1rem auto;
  margin-right: 1rem;
  display: flex;
  justify-content: end;
  font-size: 1rem;
  background: rgb(249 214 131);
  border: 2px solid black;
  letter-spacing: .1rem;
  box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
  color: black;
  width: fit-content;
  margin-right: 0;
}

@media screen and (max-width:768px) {
  a {
    font-size: .8rem;
  }

}
</style>
